export default __webpack_public_path__ + "static/media/KOD0062-min.7fcac55c.webp";